import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import booksAPI from '../../sources/api/booksAPI';

// constants
import { BOOK_UNFOLLOW } from '../../constants/booksTypes';
import { BOOK_UNFOLLOW_SUCCESS } from '../../constants/messages';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { bookListSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';

export function* bookUnfollow(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(BOOK_UNFOLLOW, call(booksAPI.unfollow, params), bookListSchema);
    yield toastr.success('success', BOOK_UNFOLLOW_SUCCESS);
  } catch (e) {
    yield toastr.error(e.response.body.message);
    yield put(error(BOOK_UNFOLLOW, e));
  } finally {
    yield put(doneIndicator(BOOK_UNFOLLOW));
  }
}

export function* watchBookUnfollow() {
  yield takeEvery(BOOK_UNFOLLOW, bookUnfollow);
}

export default function* root() {
  yield all([
    fork(watchBookUnfollow)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/bookUnfollow.js